import React from 'react';
import classes from './starfield.module.css';
import CC from '../scripts/combine-classes';

const Starfield = () => {
  const starFields = [
    new Array(5000).fill(''),
    new Array(5000).fill(''),
    new Array(500).fill(''),
  ];

  return (
    <div className={classes.bg}>
      {starFields.map((stars, index) => {
        return (
          <div
            key={`starField-${index}`}
            className={CC(
              classes.starFields,
              classes[`stars0${index + 1}`]
            )}
          >
            {stars.map((_, idx) => (
              <span
                key={`st_${index}-${idx}`}
                className={classes.star}
                style={{
                  left: `${Math.random() * 99}%`,
                  top: `${Math.random() * 98}%`,
                  opacity: `${((Math.random() * 33) + (33 * index)) / 100}`,
                }}
              >
                .
              </span>
            ))}
          </div>
        );
      })}
      <div className={classes.planet} />
    </div>
  );
};

export default Starfield;
